import { Box, Typography } from "@mui/material";
import { TechPoolChip } from "./TechPoolChip";
import { useTechPool } from "./useTechPool";
import { useSessionStatusColor } from "../useSessionStatus";
import { PoolColumnProps, TechPoolProps } from "../types.nfbAssign";

const PoolColumn = ({ label, color, entries, onOpenPreview }: PoolColumnProps) => {
	return (
		<Box sx={{ flex: "1 1 0", minWidth: 0 }}>
			<Typography
				sx={{
					fontSize: 10,
					fontWeight: 700,
					letterSpacing: "0.06em",
					textTransform: "uppercase",
					color,
					display: "flex",
					alignItems: "center",
					gap: 0.6,
					mb: "10px"
				}}
			>
				{label}
				<Box
					component="span"
					sx={{ backgroundColor: "#eeeeee", borderRadius: 99, px: 0.7, fontSize: 9.5, color: "#666666" }}
				>
					{entries.length}
				</Box>
			</Typography>
			<Box sx={{ display: "flex", flexWrap: "wrap", gap: "6px 10px", pl: "3px" }}>
				{entries.map((entry) => {
					const session = entry.session;
					return (
						<TechPoolChip
							key={entry.therapist.userId}
							therapist={entry.therapist}
							ringStatus={entry.ringStatus}
							subLabel={entry.subLabel}
							onClick={session ? () => onOpenPreview(session) : undefined}
						/>
					);
				})}
			</Box>
		</Box>
	);
};

export const TechPool = ({ sessions, meetings, currentBlock, clinics, now, onOpenPreview }: TechPoolProps) => {
	const { inSession, free } = useTechPool(sessions, meetings, currentBlock, clinics, now);
	const inSessionColor = useSessionStatusColor("in_session");

	if (inSession.length === 0 && free.length === 0) return null;

	return (
		<Box sx={{ borderTop: "1px solid #e0e0e0", pt: 1.5 }}>
			<Box sx={{ display: "flex", gap: "24px" }}>
				<PoolColumn label="Em sessão" color={inSessionColor} entries={inSession} onOpenPreview={onOpenPreview} />
				<PoolColumn label="Livre" color="#2d5a7b" entries={free} onOpenPreview={onOpenPreview} />
			</Box>
		</Box>
	);
};
